const NotFound = () =>{
    return <h1>Sorry, page not Found</h1>
}

export default NotFound